// extracted by mini-css-extract-plugin
export default {"HomePage":"HomePage_HomePage__oGHWl","Title":"HomePage_Title__fKQFK"};